// Compact number format: 12 → "12", 1234 → "1.2K", 1234567 → "1.2M".
export function formatNumber(n: number): string {
  if (n < 1000) return n.toString();
  if (n < 1_000_000) {
    const v = n / 1000;
    return v >= 10 ? `${Math.floor(v)}K` : `${v.toFixed(1).replace(/\.0$/, "")}K`;
  }
  if (n < 1_000_000_000) {
    const v = n / 1_000_000;
    return v >= 10 ? `${Math.floor(v)}M` : `${v.toFixed(1).replace(/\.0$/, "")}M`;
  }
  const v = n / 1_000_000_000;
  return v >= 10 ? `${Math.floor(v)}B` : `${v.toFixed(1).replace(/\.0$/, "")}B`;
}

// Duration in seconds → "45с", "3м 12с", "1ч 30м", "2д 4ч".
export function formatDuration(totalSeconds: number): string {
  if (totalSeconds < 0) totalSeconds = 0;
  const s = Math.floor(totalSeconds);
  if (s < 60) return `${s}с`;

  const m = Math.floor(s / 60);
  if (m < 60) {
    const rs = s % 60;
    return rs === 0 ? `${m}м` : `${m}м ${rs}с`;
  }

  const h = Math.floor(m / 60);
  if (h < 24) {
    const rm = m % 60;
    return rm === 0 ? `${h}ч` : `${h}ч ${rm}м`;
  }

  const d = Math.floor(h / 24);
  const rh = h % 24;
  return rh === 0 ? `${d}д` : `${d}д ${rh}ч`;
}

// Seconds until ISO instant, given current Date.
export function secondsUntil(iso: string, now: Date): number {
  const target = new Date(iso).getTime();
  return Math.max(0, (target - now.getTime()) / 1000);
}
